module.exports = __webpack_public_path__ + "img/Icon-block-checkup-32px-koraalrood.bd5c58e2.svg";